import { NetworkCode, Site } from '@domain/graphql.types';
import type { TFunction } from 'i18next';

/** "12/14 ports" when the filters keep only some ports, "15 ports" otherwise (and for stations without chargers). */
export const getPortsLabel = (site: Pick<Site, 'matchingPortsCount' | 'portsCount'>, t: TFunction) =>
  site.matchingPortsCount > 0 && site.matchingPortsCount < site.portsCount
    ? t('siteLookup.list.matchingPorts', { count: site.portsCount, matching: site.matchingPortsCount })
    : t('siteLookup.list.ports', { count: site.portsCount });

export type ExportStatus = 'partial' | 'none';

/**
 * Only told when the report is capped (fewer ports exported than matching): a station with some of its
 * matching ports exported is partially exported, one with none is not exported. Stations without chargers say nothing.
 */
export const getExportStatus = (site: Pick<Site, 'includedInReportPortsCount' | 'matchingPortsCount'>, isReportCapped: boolean): ExportStatus | null => {
  if (!isReportCapped || site.matchingPortsCount === 0) return null;
  if (site.includedInReportPortsCount === 0) return 'none';
  if (site.includedInReportPortsCount < site.matchingPortsCount) return 'partial';
  return null;
};

/** The network name of a station: the translated network, or the raw name of non-networked and unknown ones. */
export const getNetworkName = (site: Pick<Site, 'networkCode' | 'networkName'>, t: TFunction) => {
  if ((site.networkCode === NetworkCode.NonNetworked || site.networkCode === NetworkCode.Unknown) && !!site.networkName) {
    return site.networkName;
  }
  return t(`enum.networkCode.${site.networkCode}`);
};
